import { useEffect } from "react";

interface Props {
  condition: boolean | undefined;
}

/** Handles:
 * - Ctrl-R / F5 / tab-close
 * - Tab close
 * - Browser close
 */
export function useNavigationGuard({ condition }: Props): void {
  // native browser unload
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (!condition) {
        return;
      }

      // make browser show its own message
      e.preventDefault();
      e.returnValue = ""; // modern browsers show their own confirm text, can't be customized
    };
    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, [condition]);
}
